import { render, staticRenderFns } from "./ProductNewArrival.vue?vue&type=template&id=1e3df047&"
import script from "./ProductNewArrival.vue?vue&type=script&lang=js&"
export * from "./ProductNewArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports